import lara from '../lara'

export default {
  ...lara,
  menubar: {
    ...lara.menubar,
    menu: ({ props }) => ({
      class: [
          // Flexbox
          
          'items-center',
          'flex-wrap',
          'flex-col ',
          { hidden: !props?.mobileActive, flex: props?.mobileActive },

          // Position
          'absolute ',
          'top-full left-0',
          

          // Size
          'w-full sm:w-auto',

          // Spacing
          'm-0',
          'py-1 ',
          'list-none',

          // Shape
          'shadow-md ',
          'border-0',

          // Color
          'bg-surface-0 dark:bg-surface-700 ',

          // Misc
          'outline-none'
      ]
    }),
    menuitem: {
        class: ' w-full static'
    },
  },
  dialog: {
    ...lara.dialog,
    root: ({ state }) => ({
      ...lara.dialog.root({ state }),
      class: [
        ...lara.dialog.root({ state }).class,
        'w-[90vw]',
        'md:w-[50vw]',
      ],
    }),
  },
  // Here we can override the preset values
  // E.g.:
  // menubar: {
  //   ...lara.menubar,
  //   menuitem: {
  //     ...lara.menubar.menuitem,
  //     class: `${lara.menubar.menuitem.class} w-full`,  
  //   }
  // }
}
